import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultValue", "id", "isDisabled", "isHorizontal", "name", "onChange", "options", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import useUncontrolledProp from '@bubble-ui/hook-use-uncontrolled-prop';
import { useUniqueFormIdentifier } from '@bubble-ui/hook-use-unique-form-identifier';
import SpacerHorizontal from '@bubble-ui/atom-spacer-horizontal';
import SpacerVertical from '@bubble-ui/atom-spacer-vertical';
import View from '@bubble-ui/primitive-view';
import { RadioGroupOption } from './RadioGroupOption';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var RadioGroup = _ref => {
  var {
      defaultValue,
      id,
      isDisabled,
      isHorizontal,
      name,
      onChange,
      options,
      value
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var ids = getIds(id);
  var designVersion = useDesignVersion();

  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  var {
    wrapperStyle
  } = useStyleSheet(RadioGroup, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    defaultValue,
    designVersion,
    id,
    isDisabled,
    isHorizontal,
    name,
    onChange,
    options,
    value
  }));
  var [radioGroupValue, setRadioGroupValue] = useUncontrolledProp({
    prop: value,
    defaultProp: defaultValue,
    onChange
  });
  var componentName = useUniqueFormIdentifier({
    name,
    fallbackName: 'RadioGroup'
  });
  return /*#__PURE__*/React.createElement(View, {
    id: ids.root,
    style: wrapperStyle,
    accessibilityRole: "radiogroup"
  }, options.map((option, index) => /*#__PURE__*/React.createElement(View, {
    key: "".concat(option.value, "-").concat(index, "_wrapper"),
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement(RadioGroupOption, _extends({
    id: ids.radioGroupOption(index),
    isChecked: option.value === radioGroupValue,
    isDisabled: isDisabled,
    key: "".concat(option.value, "-").concat(index),
    name: componentName,
    onChange: setRadioGroupValue
  }, option)), index + 1 <= options.length && (isHorizontal ? /*#__PURE__*/React.createElement(SpacerHorizontal, {
    spaceToken: "space/400"
  }) : /*#__PURE__*/React.createElement(SpacerVertical, {
    spaceToken: 'space/100'
  })))));
};
RadioGroup.displayName = 'RadioGroup';
export default withProvisionalOverrideFromContext(RadioGroup);
//# sourceMappingURL=index.js.map